export class PrintRateCardConfigModel {
    constructor() {
        this.id = 0;
        this.loyaltyAmount = 0;
        this.lotusChargePercent = 0;
    }
}